// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3WqpN","title":"Images90_title__3Y3M6","images":"Images90_images__2_Ayq"};